/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  TablePagination,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function ImovelList({ refresh, onEdit, onImovelDeleted }) {
  const { user } = useAuth();
  const [imoveis, setImoveis] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchImoveis = () => {
    api.get(`/imoveis?page=${page}&limit=${rowsPerPage}`)
      .then((response) => {
        setImoveis(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => {
        console.error('Erro ao buscar im\u00F3veis:', error);
      });
  };

  useEffect(() => {
    fetchImoveis();
  }, [refresh, page, rowsPerPage]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este im\u00F3vel?')) return;
    try {
      await api.delete(`/imoveis/${id}`);
      console.log('Im\u00F3vel deletado com sucesso!');
      onImovelDeleted();
      fetchImoveis();
    } catch (error) {
      console.error('Erro ao deletar im\u00F3vel:', error);
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="imoveis table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              {user?.tipo_usuario === 'admin' && <TableCell>Empresa ID</TableCell>}
              <TableCell>Descri&ccedil;&atilde;o</TableCell>
              <TableCell>N&uacute;mero</TableCell>
              <TableCell>Bloco</TableCell>
              <TableCell>A&ccedil;&otilde;es</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {imoveis.map((imovel) => (
              <TableRow key={imovel.id} hover>
                <TableCell>{imovel.id}</TableCell>
                {user?.tipo_usuario === 'admin' && <TableCell>{imovel.empresa_id}</TableCell>}
                <TableCell>{imovel.descricao}</TableCell>
                <TableCell>{imovel.numero}</TableCell>
                <TableCell>{imovel.bloco || 'N/A'}</TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(imovel)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(imovel.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Linhas por p&aacute;gina:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default ImovelList;
